(function(){
  function run(){
    var h=document.querySelector('.ccbh-hero h1');
    if(!h||!document.getElementById('vote')||document.querySelector('.ccbh-votebtn'))return;
    var a=document.createElement('a');
    a.href='#vote';
    a.className='ccb-btn ccb-btn--sm ccbh-ghost ccbh-votebtn';
    a.textContent='Vote for our next flavour ↓';
    a.style.marginBottom='22px';
    a.addEventListener('click',function(e){
      var t=document.getElementById('vote');
      if(!t)return;
      e.preventDefault();
      t.style.scrollMarginTop='110px';
      var r=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({behavior:r?'auto':'smooth',block:'start'});
    });
    h.insertAdjacentElement('afterend',a);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
